// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/UserWorkingTimeModelSortBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/UserWorkingTimeModelSortBy.proto.
 */
export const file_Enumerations_UserWorkingTimeModelSortBy: GenFile = /*@__PURE__*/
  fileDesc("Ci1FbnVtZXJhdGlvbnMvVXNlcldvcmtpbmdUaW1lTW9kZWxTb3J0QnkucHJvdG8SGnRpbWVfdHJhY2tpbmcuZW51bWVyYXRpb25zKq0DChpVc2VyV29ya2luZ1RpbWVNb2RlbFNvcnRCeRIvCitVU0VSX1dPUktJTkdfVElNRV9NT0RFTF9TT1JUX0JZX1VOU1BFQ0lGSUVEEAASNQopVVNFUl9XT1JLSU5HX1RJTUVfTU9ERUxfU09SVF9CWV9URU5BTlRfSUQQBRoGysfNDwEFEjYKKlVTRVJfV09SS0lOR19USU1FX01PREVMX1NPUlRfQllfVkFMSURfRlJPTRAGGgbKx80PAQYSNworVVNFUl9XT1JLSU5HX1RJTUVfTU9ERUxfU09SVF9CWV9WQUxJRF9VTlRJTBAHGgbKx80PAQcSNwoqVVNFUl9XT1JLSU5HX1RJTUVfTU9ERUxfU09SVF9CWV9DUkVBVEVEX0FUEGQaB8rHzQ8CZAESOAorVVNFUl9XT1JLSU5HX1RJTUVfTU9ERUxfU09SVF9CWV9NT0RJRklFRF9BVBBlGgfKx80PAmQCEjcKKlVTRVJfV09SS0lOR19USU1FX01PREVMX1NPUlRfQllfREVMRVRFRF9BVBBmGgfKx80PAmQDIgQIARAEIgQICBBjQiiqAiVNb2dpLlRpbWVUcmFja2luZy5Db21tb24uRW51bWVyYXRpb25zYgZwcm90bzM", [file_Options_EnumValueOptions]);

/**
 * Determines by which columns to sort user and working time model associations by.
 *
 * @generated from enum time_tracking.enumerations.UserWorkingTimeModelSortBy
 */
export enum UserWorkingTimeModelSortBy {
  /**
   * Do not apply any specific sorting to the query.
   *
   * @generated from enum value: USER_WORKING_TIME_MODEL_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort the user and working time model associations by their tenant id.
   *
   * @generated from enum value: USER_WORKING_TIME_MODEL_SORT_BY_TENANT_ID = 5;
   */
  TENANT_ID = 5,

  /**
   * Sort the user and working time model associations by their validity start date.
   *
   * @generated from enum value: USER_WORKING_TIME_MODEL_SORT_BY_VALID_FROM = 6;
   */
  VALID_FROM = 6,

  /**
   * Sort the user and working time model associations by their validity end date.
   *
   * @generated from enum value: USER_WORKING_TIME_MODEL_SORT_BY_VALID_UNTIL = 7;
   */
  VALID_UNTIL = 7,

  /**
   * Sort the user and working time model associations by their creation time stamp.
   *
   * @generated from enum value: USER_WORKING_TIME_MODEL_SORT_BY_CREATED_AT = 100;
   */
  CREATED_AT = 100,

  /**
   * Sort the user and working time model associations by their modification time stamp.
   *
   * @generated from enum value: USER_WORKING_TIME_MODEL_SORT_BY_MODIFIED_AT = 101;
   */
  MODIFIED_AT = 101,

  /**
   * Sort the user and working time model associations by their deletion time stamp.
   *
   * @generated from enum value: USER_WORKING_TIME_MODEL_SORT_BY_DELETED_AT = 102;
   */
  DELETED_AT = 102,
}

/**
 * Describes the enum time_tracking.enumerations.UserWorkingTimeModelSortBy.
 */
export const UserWorkingTimeModelSortBySchema: GenEnum<UserWorkingTimeModelSortBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_UserWorkingTimeModelSortBy, 0);

